const numberFormat = (number) => Intl.NumberFormat().format(number);

export default numberFormat;
